const Parse = require("parse");

Parse.initialize(process.env.REACT_APP_APP_ID, "");
const environment = process.env.NODE_ENV || "development"; // Default to 'development' if not set
Parse.serverURL = environment === "development"
    ? process.env.REACT_APP_SERVER_URL_DEV + "/parse"
    : process.env.REACT_APP_SERVER_URL_PROD + "/parse";
module.exports = Parse;